import styled from 'styled-components';

export default {
    Modal: styled.div.attrs({ className: 'modal' })`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
        z-index: 101;
        overflow-y: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
    ModalContent: styled.div.attrs({ className: 'modal-content' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        background-color: #fff;
        z-index: 110;
        display: flex;
        flex-direction: column;
        min-height: 368px;
        height: auto;
        width: 98%;
        padding: 50px 24px 48px;
        border: 1px solid #5B6164;
        box-sizing: border-box;
        @media (max-width: 320px) {
            width: 310px;
        }
        @media (min-width: 700px) {
            width: 540px;
        }
        @media (min-width: 1000px) {
            width: 980px;
            height: 520px;
            padding-left: 70px;
            padding-right: 70px;
            padding-top: 79px;
        }
    `,
    ModalTitle: styled.h3.attrs({ className: 'modal-title' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 18px;
        font-weight: 400;
        line-height: 40px;
        color: #1A1A1A;
        display: block;
        text-align: left;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        padding: 0;
        margin: 0 0 30px;
        @media (min-width: 900px) {
            font-size: 40px;
            line-height: 44px;
            margin-bottom: 48px;
        }
    `,
    ModalTextContainer: styled.div.attrs({ className: 'modal-text-container' })`
        max-width: 839px;
        min-height: 82px;
        max-height: 342px;
        overflow-y: auto;
        margin-bottom: 10px;
        @media (min-width: 900px) {
            margin: 0 0 26px;
        }
    `,
    ModalText: styled.p.attrs({ className: 'modal-text' })`
        width: 100%;
        font-size: 16px;
        line-height: 24px;
        color: #5B6164;
        text-align: left;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        margin-top: 0;
        margin-bottom: 20px;
        
        @media(min-width: 900px) {
            font-size: 18px;
            line-height: 32px;
            letter-spacing: 0.5px;
            color: #1A1A1A;
            margin-bottom: 10px;
        }
        
    `,
    InputError: styled.span.attrs({ className: 'input-error' })`
        position: absolute;
        bottom: -20px;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        color: #B12A31;
        line-height: 32px;
        letter-spacing: 0.5px;
        @media (min-width: 900px) {
            font-size: 18px;
            line-height: 30px;
        }
    `,
};
